<template lang="html">

  <form id="formContacto" @submit.prevent="validateBeforeSubmit">

    <div class="contenedor-input">
      <input type="text" class="input-text" v-validate="'required'" name="nombre" :placeholder="$t('formulario.nombre_apellidos')+'*'" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
    </div>


    <div class="contenedor-input">
      <input type="text" class="input-text" v-validate="'required'" name="empresa" :placeholder="$t('formulario.empresa')+'*'" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('empresa') }}</span>
    </div>

    <div class="contenedor-input">
      <input type="text" class="input-text" v-validate="'required|email'" name="email" :placeholder="$t('formulario.email')+'*'" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
    </div>

    <div class="contenedor-input">
      <textarea :placeholder="$t('formulario.mensaje')+'*'" name="mensaje" v-validate="'required'"></textarea>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('mensaje') }}</span>
    </div>

    <popup-condiciones :error="errorCondiciones"></popup-condiciones>


    <div class="contenedor-check contenedor-input">
      <input id="politica" type="checkbox" v-model="form.politica" name="politica" v-validate="'required'" />
      <label for="politica">{{$t('formulario.he_leido')}} <router-link target="_blank" :to="$t('enlaces.politica_privacidad')">{{$t('formulario.y_acepto')}}</router-link>.</label>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
    </div>

    <input type="hidden" name="tipo" value="contacto">


    <button class="btn btn-dark -enviar" :clicked="sending" :sendend="sendend">
      <div class="scroller">
        <span>{{$t('formulario.enviar')}}</span>
        <span>
          <hollow-dots-spinner :animation-duration="1000" :dot-size="15" :dots-num="3" color="#054279" />
        </span>
        <span>{{$t('formulario.enviado')}}</span>
      </div>
    </button>

  </form>

</template>

<script lang="js">


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import { mapGetters, mapActions } from 'vuex'

  import popupCondiciones from '@/components/parts/popup-condiciones'

  import { HollowDotsSpinner } from 'epic-spinners'

  export default {
    name: 'formulario',
    props: [],
    mounted() {

    },
    data() {
      return {
        clicked: false,
        condiciones: false,
        sending: false,
        sendend: false,
        form: {
          politica: false
        }
      }
    },
    components: {
      'popup-condiciones': popupCondiciones,
      HollowDotsSpinner
    },
    methods: {
      ...mapActions(['sendContacto']),
      validateBeforeSubmit: function () {
        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            // this.sending = true;
            $.ajax({
              url: `https://dmb-ajusa.dev.doubledot.es/api/contacto`,
              type: 'POST',
              data: $("#formContacto").serialize(),

            })
              .done(function (r) {
                if (r.status) {
                  $(".contenedor-input *").val('');
                  $("#formContacto")[0].reset();
                  // this.form.politica = false;
                  this.clicked = false;
                  this.sendend = false;
                  this.sending = false;

                }
              })
              .fail(function (error) {
                console.log(error);
              })
              .always(function () {
                $(".contenedor-input *").val('');
                $("#formContacto")[0].reset();
                // this.form.politica = false;
                this.clicked = false;
                this.sendend = false;
                this.sending = false;
                setTimeout(function () {
                  scroll({
                    behavior: "smooth",
                    top: 0,
                  });
                }, 200);
              });
          }
        });
      },
      showCondiciones: function () {
        this.condiciones = true;
      },
    },
    computed: {
      errorCondiciones: function () {
        let flag = (!this.condiciones && this.clicked) ? true : false;
        return flag;
      },
    }
  }
</script>

<style scoped>
  .contenedor-input .error {
    bottom: -14px;
  }


  .select-style.contenedor-input .error {
    bottom: -24px;
  }

  .contenedor-check.contenedor-input {
    padding-bottom: 10px;
  }

  .btn.-enviar {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;
    max-width: 270px;
    height: 57px;
    padding: 0;
    outline: none;
    width: 100%;
  }

  .scroller {
    transition: .4s;
    width: 100%;
  }

  .btn[clicked="true"] .scroller {
    transform: translateY(-33.333333333%);
  }

  .btn[sendend="true"] .scroller {
    transform: translateY(-66.6666666666%);
  }


  .btn span {
    height: 57px;
    line-height: 57px;
    width: 100%;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-align-items: center;
    align-items: center;
    width: 100%;
  }

  .btn span:last-of-type {
    background: #054279;
    color: #fff;
  }

  /*@media only screen and (max-width: 800px) {
  .btn.-enviar{
    width: 200px;
  }
  }*/
</style>


// WEBPACK FOOTER //
// src/components/view-parts/contacto/formulario.vue